import { createContext } from 'react';
import * as React from 'react';

interface PhaseErrorContextProps {
	isErrorPhaseMessage: boolean;
	setIsErrorPhaseMessage:
		| React.Dispatch<React.SetStateAction<boolean>>
		| ((value: boolean) => void);
	errorPhaseMessage: string;
	setErrorPhaseMessage: (value: string) => void;
}

export const PhaseErrorContext = createContext<PhaseErrorContextProps>({
	isErrorPhaseMessage: false,
	setIsErrorPhaseMessage: () => null,
	errorPhaseMessage: '',
	setErrorPhaseMessage: () => null,
});
